export const EXPERIMENT_NO_ADS = "noAds";
export const EXPERIMENT_SFW = "sfw";
export const EXPERIMENT_LITE_DELAYED_AV = "032-lite-delayed-av-prompt-experiment";
export const EXPERIMENT_MOBILE_FULLSCREEN = "mobile_fullscreen";

export const MOBILE_FULLSCREEN_VARIANT_A = "A";
export const MOBILE_FULLSCREEN_VARIANT_B = "B";
export const MOBILE_FULLSCREEN_VARIANT_C = "C";

export type TMobileFullscreenVariant =
  typeof MOBILE_FULLSCREEN_VARIANT_A |
  typeof MOBILE_FULLSCREEN_VARIANT_B |
  typeof MOBILE_FULLSCREEN_VARIANT_C;

export const VARIANT_CONTROL = "control";
const VARIANT_OFF = "off";
export const VARIANT_TREATMENT = "treatment";

export const EXPERIMENT_COVERAGE_MAP: { [key: string]: number } = {};

export const LITE_DELAYED_AV_VARIANT_LIST = [
  {
    label: "treatment (3 gifs)",
    value: VARIANT_TREATMENT
  },
  {
    label: "control (4 gifs)",
    value: VARIANT_CONTROL
  },
  {
    label: "off",
    value: VARIANT_OFF
  },
];

export const MOBILE_FULLSCREEN_VARIANT_LIST = [
  {
    label: "A — control",
    value: MOBILE_FULLSCREEN_VARIANT_A
  },
  {
    label: "B — fullscreen persists on scroll",
    value: MOBILE_FULLSCREEN_VARIANT_B
  },
  {
    label: "C — fullscreen exits on scroll",
    value: MOBILE_FULLSCREEN_VARIANT_C
  },
];
